export type InvitationAcceptedAction = {
	type: 'INVITATION_ACCEPTED';
};

export default (): InvitationAcceptedAction => ({
	type: 'INVITATION_ACCEPTED',
});
